/*eslint-disable*/
import React from 'react';
import {
	Avatar,
	Card,
	CardContent,
	Typography,
	LinearProgress,
	ExpansionPanel,
	ExpansionPanelSummary,
	ExpansionPanelDetails,
	Button,
	Icon,
	CircularProgress,
	TextField,
	InputAdornment,
	Chip
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import GridItem from 'components/Grid/GridItem.jsx';

import GridContainer from 'components/Grid/GridContainer.jsx';

import { getClientDocuments } from 'queries/ClientDocuments';
import { graphql, Mutation, Query } from 'react-apollo';
import { connect } from 'react-redux';
import { GetUserToken, Logout } from 'helpers/UserHelper';
import { Redirect } from 'react-router';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import UploadModal from './UploadModal.jsx';
import FileCard from './FileCard.jsx';
import gql from 'graphql-tag';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import SweetAlert from 'react-bootstrap-sweetalert';
import { getExtension } from 'helpers/Documents.js';

import QuoteCard from './QuoteCard.jsx';
import { SearchDataSet } from 'helpers/Search';

import { RemoveSavedQuote } from 'queries/document/mutations';
import { ParseGraphqlError } from 'helpers/ErrorHelper';
import { ParseUriParams } from 'helpers/UriReader';

const deleteMutation = gql`
	mutation deleteClientDocument($input: DeleteClientDocumentInput!) {
		DeleteClientDocument(input: $input) {
			clientMutationId
		}
	}
`;

const Wrapper = props => (
	<Card>
		<CardContent>
			<Grid container style={{ marginBottom: '15px' }}>
				<Grid
					item
					xs={12}
					sm={12}
					md={10}
					style={{
						textAlign: 'center',
						margin: '0px auto'
					}}
				>
					<Typography variant="headline" gutterBottom>
						Documents
					</Typography>
					<div
						style={{
							borderBottom: '1px solid #cccccc69',
							margin: '5px auto',
							width: '15%',
							marginBottom: '20px'
						}}
					/>
					<Typography variant="subheading" gutterBottom>
						{props.scd_name} {props.scd_surname}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={12} md={10} style={{ margin: 'auto' }}>
					{props.children}
				</Grid>
			</Grid>
		</CardContent>
	</Card>
);

const NoWrapper = props => (
	<Grid container>
		<Grid item xs={12} sm={12} md={12} style={{ margin: 'auto' }}>
			{props.children}
		</Grid>
	</Grid>
);

class ClientDocuments extends React.Component {
	state = {
		openUploadDialog: false,
		alert: null,
		chosenFolderId: '',
		chosenFolderName: '',
		documentsUpdated: false,
		deleteDialogOpen: false,
		selectedDocumentForDeletion: {},
		panels: {},
		searchTerm: '',
		loadingDelete: false,
		errorDialogOpen: false,
		errorDialogMessage: '',
		savedQuotesOpen: true,
		quotesSearchTerm: '',
		savedQuotes: [],
		filteredQuotes: [],
		removeQuoteDialog: false,
		selectedSavedQuote: {}
	};

	handelOpenUploadDialog = f => {
		this.setState({
			chosenFolderId: f.folder_Id,
			chosenFolderName: f.folder_Name,
			openUploadDialog: true
		});
	};

	handelCloseUploadDialog = updateDocuments => {
		this.setState({
			openUploadDialog: false,
			chosenFolderId: '',
			chosenFolderName: '',
			documentsUpdated: updateDocuments
		});
	};

	downloadFile = path => {
		window.open(path, '_blank');
	};

	togglePanel = id => {
		var panels = { ...this.state.panels };

		Object.keys(panels).map(key => {
			if (parseInt(key) === id) {
				panels[key].open = !panels[key].open;
			} else {
				panels[key].open = false;
			}
		});

		this.setState({ panels: panels });
	};

	handleSearch = (event, id) => {
		var panels = { ...this.state.panels };
		panels[id].searchTerm = event.target.value;

		this.setState({ panels: panels });
	};

	getopen = id => {
		return this.state.panels[id] && this.state.panels[id].open ? true : false;
	};

	successDelete = () => {
		this.setState({
			alert: (
				<SweetAlert
					success
					title="Deleted!"
					onConfirm={() => this.hideAlert()}
					onCancel={() => this.hideAlert()}
					confirmBtnCssClass={
						this.props.classes.button + ' ' + this.props.classes.success
					}
				>
					File deleted successfully
				</SweetAlert>
			)
		});
	};

	successAdd = () => {
		this.setState({
			alert: (
				<SweetAlert
					success
					title="File Uploaded!"
					onConfirm={() => this.hideAlert()}
					onCancel={() => this.hideAlert()}
					confirmBtnCssClass={
						this.props.classes.button + ' ' + this.props.classes.success
					}
				/>
			)
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	handleSearchSavedQuote = (event = null) => {
		let values = this.state.quotesSearchTerm.split(' ');

		if (event) {
			this.setState({ quotesSearchTerm: event.target.value });
			values = event.target.value.split(' ');
		}

		var docData = this.state.savedQuotes;
		var inc = ['description', 'date_saved'];

		var filteredData = SearchDataSet(docData, values, inc);

		this.setState({ filteredQuotes: filteredData });
	};

	handleQuoteView = taskguid => {
		sessionStorage.setItem('QuoteresultId', taskguid);

		this.props.history.push({
			pathname: '/app/quoteresult',
			search: `guid=${taskguid}`
		});
	};

	render() {
		let clientId = null;
		if (this.props.clientId) {
			clientId = this.props.clientId;
		} else {
			const params = ParseUriParams(this.props.location.search);
			clientId = params.clientId;
		}

		return (
			<Query
				query={getClientDocuments}
				variables={{
					id: clientId,
					token: GetUserToken()
				}}
				fetchPolicy="network-only"
			>
				{({ loading, error, data, refetch }) => {
					if (loading) {
						return <LinearProgress />;
					}
					if (
						error &&
						error.message &&
						error.message === 'GraphQL error: invalid token'
					) {
						Logout();
						return <Redirect to="/app/portal/login" />;
					}

					if (error) return `Error! ${error.message}`;

					if (this.state.documentsUpdated) {
						this.setState({ documentsUpdated: false });
						refetch();
					}

					let docData = data.ClientDocuments;

					var panels = { ...this.state.panels };

					if (Object.keys(this.state.panels).length < 1) {
						docData.folders.map((f, i) => {
							if (!panels[f.folder_Id]) {
								panels[f.folder_Id] = { open: i === 0, searchTerm: '' };
							}
						});
						this.setState({ panels: panels });
					}

					if (this.state.savedQuotes.length !== docData.saved_quotes.length) {
						this.setState({ savedQuotes: docData.saved_quotes.slice() });
					}

					let savedQuotesData = [];

					if (this.state.quotesSearchTerm !== '') {
						savedQuotesData = this.state.filteredQuotes.slice();
					} else {
						savedQuotesData = docData.saved_quotes.slice();
					}

					const body = (
						<Mutation
							mutation={deleteMutation}
							onCompleted={docData => {
								this.successDelete();
								this.setState({
									deleteDialogOpen: false,
									selectedDocumentForDeletion: {},
									loadingDelete: false
								});
								refetch();
							}}
							onError={error => {
								this.setState({
									errorDialogOpen: true,
									errorDialogMessage: ParseGraphqlError(error),
									loadingDelete: false
								});
							}}
						>
							{mutate => (
								<React.Fragment>
									<ExpansionPanel
										expanded={this.state.savedQuotesOpen}
										onChange={() => {
											let open = this.state.savedQuotesOpen;
											this.setState({ savedQuotesOpen: !open });
										}}
										style={{ margin: '16px 0px' }}
									>
										<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
											<Typography>Saved Quotes</Typography>
										</ExpansionPanelSummary>
										<ExpansionPanelDetails>
											<GridContainer
												style={{
													maxHeight: '35vh',
													overflowY: 'auto'
												}}
											>
												<GridItem
													xs={12}
													sm={12}
													md={10}
													style={{
														margin: 'auto',
														marginBottom: '2vh'
													}}
												>
													<TextField
														fullWidth
														style={{
															margin: 'auto'
														}}
														placeholder="Search"
														onChange={e => this.handleSearchSavedQuote(e)}
														InputProps={{
															startAdornment: (
																<InputAdornment position="start">
																	<Icon>search</Icon>
																</InputAdornment>
															)
														}}
													/>
												</GridItem>
												<GridItem xs={12} sm={12} md={12}>
													{this.state.quotesSearchTerm !== '' &&
													savedQuotesData.length === 0 ? (
														<Typography gutterBottom variant="caption">
															No results
														</Typography>
													) : null}
													{this.state.quotesSearchTerm === '' &&
													this.state.savedQuotes.length === 0 ? (
														<Typography gutterBottom variant="caption">
															No saved quotes for this client yet.
														</Typography>
													) : null}
												</GridItem>
												{savedQuotesData.map((q, i) => {
													return (
														<GridItem xs={12} sm={6} md={4} key={i}>
															<QuoteCard
																title={q.description}
																desc={q.date_saved.split(' ')[0]}
																history={this.props.history}
																handleView={() =>
																	this.handleQuoteView(q.fk_sq_taskguid)
																}
																handleRemove={() => {
																	this.setState({
																		removeQuoteDialog: true,
																		selectedSavedQuote: q
																	});
																}}
															/>
														</GridItem>
													);
												})}
											</GridContainer>
										</ExpansionPanelDetails>
									</ExpansionPanel>

									{docData.folders.map((f, i) => {
										return (
											<ExpansionPanel
												expanded={this.getopen(f.folder_Id)}
												key={i}
												onChange={() => this.togglePanel(f.folder_Id)}
												style={{ margin: '16px 0px' }}
											>
												<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
													<Typography>{f.folder_Name}</Typography>
												</ExpansionPanelSummary>
												<ExpansionPanelDetails>
													<GridContainer
														style={{
															maxHeight: '35vh',
															overflowY: 'auto'
														}}
													>
														<GridItem
															xs={12}
															sm={12}
															md={10}
															style={{
																margin: 'auto',
																marginBottom: '2vh'
															}}
														>
															<TextField
																fullWidth
																style={{
																	margin: 'auto'
																}}
																placeholder="Search"
																onChange={e =>
																	this.handleSearch(e, f.folder_Id)
																}
																InputProps={{
																	startAdornment: (
																		<InputAdornment position="start">
																			<Icon>search</Icon>
																		</InputAdornment>
																	)
																}}
															/>
														</GridItem>
														<GridItem
															xs={12}
															sm={12}
															md={12}
															style={{
																margin: 'auto',
																textAlign: 'center',
																marginBottom: '2vh'
															}}
														>
															<Chip
																avatar={
																	<Avatar
																		style={{
																			backgroundColor: '#6c5cab',
																			color: 'white'
																		}}
																	>
																		<Icon>add</Icon>
																	</Avatar>
																}
																className="customChip"
																variant="outlined"
																label={
																	<Typography
																		style={{
																			color: 'white'
																		}}
																	>
																		Upload File
																	</Typography>
																}
																color="secondary"
																style={{
																	backgroundColor: '#4239d659',
																	color: 'white'
																}}
																onClick={() => this.handelOpenUploadDialog(f)}
															/>
														</GridItem>
														<GridItem xs={12} sm={12} md={12}>
															{this.state.panels[f.folder_Id] &&
															this.state.panels[f.folder_Id].searchTerm !==
																'' &&
															f.documents.filter(x =>
																x.cdoc_title.includes(
																	this.state.panels[f.folder_Id].searchTerm
																)
															).length === 0 ? (
																<Typography gutterBottom variant="caption">
																	No results
																</Typography>
															) : null}
															{f.documents.length === 0 &&
															this.state.panels[f.folder_Id] &&
															this.state.panels[f.folder_Id].searchTerm ===
																'' ? (
																<Typography gutterBottom variant="caption">
																	There are no documents in this folder yet
																</Typography>
															) : null}
														</GridItem>

														{(this.state.panels[f.folder_Id] &&
														this.state.panels[f.folder_Id].searchTerm !== ''
															? f.documents.filter(x =>
																	x.cdoc_title.includes(
																		this.state.panels[f.folder_Id].searchTerm
																	)
															  )
															: f.documents
														).map((d, di) => {
															return (
																<GridItem xs={12} sm={6} md={4} key={di}>
																	<FileCard
																		imgSrc={
																			'/assets/logo/file_types/' +
																			getExtension(d.cdoc_path).replace(
																				'.',
																				''
																			) +
																			'.png'
																		}
																		title={d.cdoc_title}
																		desc={d.cdoc_desc}
																		dateCreated={d.cdoc_datecreated}
																		docPath={d.cdoc_path}
																		downloadFile={this.downloadFile}
																		deleteFile={() => {
																			this.setState({
																				deleteDialogOpen: true,
																				selectedDocumentForDeletion: d
																			});
																		}}
																	/>
																</GridItem>
															);
														})}
													</GridContainer>
												</ExpansionPanelDetails>
											</ExpansionPanel>
										);
									})}
									<UploadModal
										open={this.state.openUploadDialog}
										closeDialog={this.handelCloseUploadDialog}
										clientId={clientId}
										name={docData.scd_name}
										surname={docData.scd_surname}
										folderName={this.state.chosenFolderName}
										folderId={this.state.chosenFolderId}
										added={this.successAdd}
									/>
									{this.state.deleteDialogOpen ? (
										<SweetAlert
											warning
											style={{ wordWrap: 'break-word' }}
											title={
												'Delete file: ' +
												this.state.selectedDocumentForDeletion.cdoc_title +
												'?'
											}
											onConfirm={() => {
												mutate({
													variables: {
														input: {
															documentId: this.state.selectedDocumentForDeletion
																.id,
															documentPath: this.state
																.selectedDocumentForDeletion.cdoc_path,
															token: GetUserToken()
														}
													}
												});
												this.setState({ loadingDelete: true });
											}}
											onCancel={() => {
												this.setState({
													deleteDialogOpen: false,
													selectedDocumentForDeletion: {}
												});
											}}
											confirmBtnCssClass={
												this.props.classes.button +
												' ' +
												this.props.classes.success
											}
											cancelBtnCssClass={
												this.props.classes.button +
												' ' +
												this.props.classes.danger
											}
											confirmBtnText="Delete"
											cancelBtnText="Cancel"
											showCancel={!this.state.loadingDelete}
											showConfirm={!this.state.loadingDelete}
										>
											{this.state.loadingDelete ? (
												<div style={{ textAlign: 'center' }}>
													<CircularProgress color="secondary" size={30} />
												</div>
											) : (
												'You will not be able to recover this file!'
											)}
										</SweetAlert>
									) : null}

									{this.state.removeQuoteDialog ? (
										<Mutation
											mutation={RemoveSavedQuote}
											onCompleted={data => {
												this.successDelete();
												this.setState({
													removeQuoteDialog: false,
													selectedSavedQuote: {},
													loadingDelete: false
												});
												refetch();
												this.handleSearchSavedQuote();
											}}
											onError={error => {
												var msg = error
													.toString()
													.replace('Error: ', '')
													.replace('GraphQL error: ', '');
												this.setState({
													errorDialogOpen: true,
													errorDialogMessage: msg,
													loadingDelete: false
												});
											}}
										>
											{removeQuote => (
												<SweetAlert
													warning
													style={{ wordWrap: 'break-word' }}
													title={
														'Remove Quote: ' +
														this.state.selectedSavedQuote.description +
														'?'
													}
													onConfirm={() => {
														removeQuote({
															variables: {
																input: {
																	id: this.state.selectedSavedQuote.id,
																	token: GetUserToken()
																}
															}
														});
														this.setState({ loadingDelete: true });
													}}
													onCancel={() => {
														this.setState({
															removeQuoteDialog: false,
															selectedSavedQuote: {}
														});
													}}
													confirmBtnCssClass={
														this.props.classes.button +
														' ' +
														this.props.classes.success
													}
													cancelBtnCssClass={
														this.props.classes.button +
														' ' +
														this.props.classes.danger
													}
													confirmBtnText="Delete"
													cancelBtnText="Cancel"
													showCancel={!this.state.loadingDelete}
													showConfirm={!this.state.loadingDelete}
												>
													{this.state.loadingDelete ? (
														<div style={{ textAlign: 'center' }}>
															<CircularProgress color="secondary" size={30} />
														</div>
													) : (
														'This quote will be removed from your saved quotes, but you will still be able to view it in quote history.'
													)}
												</SweetAlert>
											)}
										</Mutation>
									) : null}

									{this.state.alert}
									{this.state.errorDialogOpen ? (
										<SweetAlert
											danger
											title={'An error has occurred'}
											onConfirm={() => {
												this.setState({
													errorDialogOpen: false,
													errorDialogMessage: ''
												});
											}}
											onCancel={() => {
												this.setState({
													errorDialogOpen: false,
													errorDialogMessage: ''
												});
											}}
											confirmBtnCssClass={
												this.props.classes.button +
												' ' +
												this.props.classes.info
											}
											confirmBtnText="Ok"
										>
											{this.state.errorDialogMessage}
										</SweetAlert>
									) : null}
								</React.Fragment>
							)}
						</Mutation>
					);

					if (this.props.clientId) {
						return <NoWrapper>{body}</NoWrapper>;
					}
					return (
						<Wrapper
							scd_name={docData.scd_name}
							scd_surname={docData.scd_surname}
						>
							{body}
						</Wrapper>
					);
				}}
			</Query>
		);
	}
}

export default withStyles(sweetAlertStyle)(ClientDocuments);



// WEBPACK FOOTER //
// ./src/views/Documents/ClientDocuments.jsx